<template>
  <v-container fluid class="pa-0 test" style="background-color:#fff">
    <v-card color="white" flat>
      <v-toolbar class="custom" color="white" elevation="0" fixed height="120">
        <v-toolbar-title class=" purple--text mr-2" style="overflow:show;">
          <v-img :src="require('../assets/logo.png')" width="70px"> </v-img>
        </v-toolbar-title>
        <v-toolbar-title
          class="font-weight-bold"
          style="font-size:1.3rem;bottom: -5px; position:relative;width:260px;"
        >
          SINAR FASTENER
          <div
            class="mt-0 primary--text"
            style="letter-spacing: 8px;font-weight: 400px;top: -7px; position:relative;"
          >
            INDONESIA
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-divider vertical inset></v-divider>
        <v-list three-line max-width="20%">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="#0081db">mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold mb-2">
                Kontak Kami
              </v-list-item-title>
              <v-list-item-subtitle>021-599-0860</v-list-item-subtitle>
              <v-list-item-subtitle>0878-7659-3469</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list three-line max-width="27%" class="mr-10">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="#0081db">mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold mb-2">
                Kantor Kami
              </v-list-item-title>
              <v-list-item-subtitle
                >Perum Tigaraksa Blok AJ 47/10 Tangerang,
                Banten</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-btn
          color="#0081db"
          outlined
          tile
          class="font-weight-regular"
          to="/contact"
        >
          HUBUNGI KAMI
        </v-btn>
      </v-toolbar>
      <v-divider class="mx-auto" width="90%"></v-divider>
      <v-toolbar class="custom" color="white" elevation="0" height="80">
        <v-btn text tile to="/" class="font-weight-bold" height="80">
          BERANDA
        </v-btn>
        <v-btn text tile to="/services" class="font-weight-bold" height="80">
          LAYANAN
        </v-btn>
        <v-btn text tile to="/projects" class="font-weight-bold" height="80">
          PORTOFOLIO
        </v-btn>
        <v-btn
          color="#0081db"
          text
          tile
          to="/about"
          class="font-weight-bold"
          height="80"
        >
          TENTANG
        </v-btn>
        <v-btn
          text
          tile
          class="font-weight-bold"
          to="/contact"
          height="80"
          v-scroll-to="{ el: '#element', offset: -30 }"
        >
          KONTAK
        </v-btn>
        <v-spacer />
        <v-icon @click="alert" color="black">
          mdi-magnify
        </v-icon>
      </v-toolbar>
      <v-card width="100%" color="#f8f8f8" elevation="0" class="paralaxGrad">
        <v-row align="center" justify="space-between" class="paralax">
          <h1
            class="display-1 font-weight-bold pa-4 white--text ml-4"
            color="primary"
          >
            TENTANG KAMI
          </h1>
          <v-breadcrumbs :items="breadcumbs">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-row>
      </v-card>
    </v-card>

    <v-row class="custom">
      <v-col cols="8">
        <v-card-text class="title font-weight-bold">SEJARAH KAMI</v-card-text>
        <v-divider class="ml-4 mt-0"></v-divider>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" class="py-2">
              <p class="text-justify" style="text-indent: 50px;">
                PT. Sinar Fastener Indonesia perusahaan yang bergerak di bidang
                pengadaan barang konstruksi dan jasa kontraktor yang melayani
                perusahaan kecil, menengah dan perusahaan besar, baik swasta dan
                pemerintahan dengan diawali dengan berdirinya usaha CV. Sinar
                Galvanis Metal sejak tahun 2002. Kami menyediakan solusi bisnis
                yang jujur dan amanah kepada perusahaan yang menjadi mitra kami
                dimana hal yang menjadi keutamaan kami selalu mengutamakan
                kepuasan pelanggan serta kepercayaan demi kelangsungan bisnis
                yang harmonis dan berkelanjutan.
              </p>
              <p class="text-justify" style="text-indent: 50px;">
                Kami sangat menjaga mutu dan hasil yang terbaik dalam pekerjaan
                yang kami tangani. Dengan tujuan kami adalah untuk menjadi
                pilihan utama bagi mitra bisnis kami dengan memberikan
                kontribusi yang optimal kepada setiap klien kami sesuai yang
                diharapkan melalui pelayanan istimewa dari kami secara
                profesional dan integritas penuh.Keunggulan kami adalah memiliki
                lini lini sektor yang sudah kami dapat proses sendiri, sehingga
                menjadikan kualitas terjamin dan terpantau dari produk produk
                yang kami miliki. Karena dengan itu kami optimis dengan memiliki
                sumber daya yang tinggi baik di sektor sumber daya manusia,
                sumber daya bahan baku, kami dapat menghasilkan kualitas
                pekerjaan dan pelayanan yang baik sesuai yang di harapkan mitra
                bisnis kami.
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="4" class="pa-4">
        <v-card elevation="2" max-width="444" class="mx-auto">
          <v-carousel
            :continuous="false"
            :cycle="cycle"
            :show-arrows="false"
            height="300"
          >
            <v-carousel-item v-for="(slide, i) in slides" :key="i">
              <v-sheet :color="colors[i]" height="100%" tile>
                <v-row class="fill-height pa-8" align="center">
                  <p class="text-center">" {{ slide }} "</p>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
          <v-list two-line>
            <v-list-item>
              <v-list-item-avatar>
                <v-img :src="require('../assets/logo.png')"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  >PT Sinar Fastener Indonesia</v-list-item-title
                >
                <v-list-item-subtitle>Visi dan Misi</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-divider class=" mx-auto" width="90%"></v-divider>
    <v-sheet
      class="mt-10"
      max-width="100%"
      color="white"
      min-height="500"
      elevation="0"
    >
      <div id="about">
        <h2
          class="text-center  font-weight-bold mt-1 mb-6 black--text"
          id="element"
        >
          MENGAPA MEMILIH KAMI
        </h2>
      </div>
      <br />
      <br />
      <v-card width="90%" class="mx-auto" elevation="0">
        <v-row align="center" justify="center" class="text-center">
          <v-col cols="12" md="3" sm="6" class="text-center mr-0">
            <v-card height="315" elevation="0">
              <center>
                <v-icon class="mx-auto" size="85" color="#008db1">
                  mdi-account-multiple-check
                </v-icon>
              </center>
              <h4
                class="font-weight-bold mb-7 mt-5"
                style="font-size:18px;font-weight:600;font-family:lato,helveticaneue,helvetica neue,Helvetica,Arial,sans-serif"
              >
                Amanah
              </h4>
              <p style="color:#666">
                Kami menyediakan solusi bisnis yang jujur dan amanah kepada
                perusahaan yang menjadi mitra kami dimana hal yang menjadi
                keutamaan kami selalu mengutamakan kepuasan pelanggan serta
                kepercayaan demi kelangsungan bisnis yang harmonis dan
                berkelanjutan
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" sm="6" class="text-center">
            <v-card height="315" elevation="0">
              <center>
                <v-icon class="mx-auto" size="85" color="#008db1">
                  mdi-check-decagram
                </v-icon>
              </center>
              <h4
                class="font-weight-bold mb-7 mt-5"
                style="font-size:18px;font-weight:600;font-family:lato,helveticaneue,helvetica neue,Helvetica,Arial,sans-serif"
              >
                Pelayanan Istimewa
              </h4>
              <p style="color:#666">
                Tujuan kami adalah untuk menjadi pilihan utama bagi mitra bisnis
                kami dengan memberikan kontribusi yang optimal kepada setiap
                klien kami sesuai yang diharapkan melalui pelayanan istimewa
                dari kami secara profesional dan integritas penuh
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" sm="6" class="text-center">
            <v-card height="315" elevation="0">
              <center>
                <v-icon class="mx-auto" size="85" color="#008db1">
                  mdi-shield-check
                </v-icon>
              </center>
              <h4
                class="font-weight-bold mb-7 mt-5"
                style="font-size:18px;font-weight:600;font-family:lato,helveticaneue,helvetica neue,Helvetica,Arial,sans-serif"
              >
                Kualitas Terjamin
              </h4>
              <p style="color:#666">
                Keunggulan kami adalah memiliki lini lini sektor yang sudah kami
                dapat proses sendiri, sehingga menjadikan kualitas terjamin dan
                terpantau dari produk produk yang kami miliki.
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" sm="6" class="text-center">
            <v-card height="315" elevation="0">
              <center>
                <v-icon class="mx-auto" size="85" color="#008db1">
                  mdi-tag-multiple
                </v-icon>
              </center>
              <h4
                class="font-weight-bold mb-7 mt-5"
                style="font-size:18px;font-weight:600;font-family:lato,helveticaneue,helvetica neue,Helvetica,Arial,sans-serif"
              >
                SUMBER DAYA TERBAIK
              </h4>
              <p style="color:#666">
                Kami optimis dengan memiliki sumber daya yang tinggi baik di
                sektor sumber daya manusia, sumber daya bahan baku, kami dapat
                menghasilkan kualitas pekerjaan dan pelayanan yang baik sesuai
                yang di harapkan mitra bisnis kami.
              </p>
            </v-card>
          </v-col>
          <v-btn
            color="#0081db"
            dark
            outlined
            tile
            class="font-weight-bold  mx-auto my-10"
            to="contact"
          >
            HUBUNGI KAMI
          </v-btn>
        </v-row>
      </v-card>
    </v-sheet>
    <v-sheet class="mx-auto my-10" max-width="900">
      <div id="mitra">
        <p
          class="text-center display-1 font-weight-bold mt-1 mb-6 black--text"
          id="element"
        >
          MITRA KAMI
        </p>
        <v-divider class="mb-10 mx-auto" width="90%"></v-divider>
      </div>
      <v-slide-group v-model="model" center-active show-arrows>
        <v-slide-item
          v-for="n in mitra"
          :key="n.title"
          v-slot:default="{ active, toggle }"
        >
          <v-img
            :src="n.img"
            class="ma-2"
            max-height="100"
            max-width="250"
            width="250"
            @click="toggle"
            style="cursor:pointer"
          >
            <v-row class="fill-height" align="center" justify="center">
              <v-scale-transition>
                <v-card
                  v-if="active"
                  :color="active ? 'primary' : 'grey lighten-1'"
                  height="100"
                  width="250"
                >
                  <v-card-text class="text-center white--text mt-3">
                    {{ n.title }}
                  </v-card-text>
                </v-card>
              </v-scale-transition>
            </v-row>
          </v-img>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
    <v-footer padless>
      <v-card flat tile class="text-center pt-10" color="black">
        <v-row class="text-left custom-margin-footer">
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">TENTANG</h2>
              <p class="darken-4 grey--text mt-3">
                PT. Sinar Fastener Indonesia adalah perusahaan yang bergerak di
                bidang pengadaan barang konstruksi dan jasa kontraktor yang
                melayani perusahaan kecil, menengah dan perusahaan besar, baik
                swasta dan pemerintahan dengan diawali dengan berdirinya usaha
                CV. Sinar Galvanis Metal sejak tahun 2002. Kami menyediakan
                solusi bisnis yang jujur dan amanah kepada perusahaan yang
                menjadi mitra kami dimana hal yang menjadi keutamaan kami selalu
                mengutamakan kepuasan pelanggan serta kepercayaan demi
                kelangsungan bisnis yang harmonis dan berkelanjutan
              </p>
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">HELPFUL LINKS</h2>
              <ul class="darken-4 grey--text mt-3">
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/services"
                      class="blue--text"
                      style="text-decoration: none"
                      >Layanan</a
                    >
                  </h3>
                </li>
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/projects"
                      class="blue--text"
                      style="text-decoration: none"
                      >Portofolio</a
                    >
                  </h3>
                </li>
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/about"
                      class="blue--text"
                      style="text-decoration: none"
                      >Tentang</a
                    >
                  </h3>
                </li>
                <li>
                  <h3>
                    <a
                      href="/#/contact"
                      class="blue--text"
                      style="text-decoration: none"
                      >Kontak</a
                    >
                  </h3>
                </li>
              </ul>
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">KONTAK KAMI</h2>
              <p class="mt-3 darken-2 grey--text">
                Perum Tigaraksa BLOK AJ 47/10, Kel. Margasari, Kec. Tigaraksa,
                Kab. Tangerang, Prov. Banten
              </p>
              <p class="mt-3 darken-2 grey--text">
                Phone:
                <span class="white--text"> 021-599-0860 / 0878-7659-3469</span>
              </p>
              <p class="mt-3 darken-2 grey--text">
                Email:
                <a
                  href="mailto:marketing@sinarfastenerindonesia.com"
                  class="white--text"
                >
                  marketing@sinarfastenerindonesia.com
                </a>
              </p>
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider color="grey"></v-divider>
        <v-card-text>
          <v-btn
            v-for="icon in iconsFooter"
            :key="icon"
            class="mx-4 blue--text"
            icon
          >
            <v-icon size="24px">{{ icon }}</v-icon>
          </v-btn>
        </v-card-text>
        <div>
          <v-divider color="grey"></v-divider>
          <v-card-text class="darken-4 grey--text">
            © Copyright 2020 by
            <a
              href="#"
              class="blue--text font-weight-bold"
              style="text-decoration: none"
              >Sinar Fastener</a
            >. All Rights Reserved.
          </v-card-text>
        </div>
      </v-card>
    </v-footer>
    <!-- <v-parallax
      dark
      src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col class="text-center" cols="12">
          <h1 class="display-1 font-weight-thin mb-4">Vuetify.js</h1>
          <h4 class="subheading">Build your application today!</h4>
        </v-col>
      </v-row>
    </v-parallax> -->
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      colors: ["navy", "primary"],
      cycle: false,
      slides: [
        "Bekerja untuk membangun perusahaan yang selalu berpegang pada amanah dalam menjalankan pelayanan.",
        "Mengutamakan kepuasan pelanggan sebagai dasar amanah yang telahdiberikan.Memilih mitra kerja yang handal dan menjadikan bagian dari tim dalam bekerja agar tercapai dalam mewujudkan tujuan untuk memberi kepuasan kepada pelanggan.Memiliki SDM yang tidak hanya berintegrasi dan profesional ,tetapijuga memiliki akhlak yang baik sebagai dasar untuk meningkatkinerja perusahaan.",
      ],
      icons: ["mdi-rewind"],
      iconsFooter: [
        "mdi-facebook",
        "mdi-twitter",
        "mdi-google-plus",
        "mdi-linkedin",
        "mdi-instagram",
      ],
      itemProject: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
      mitra: [
        {
          title: "PT. BUKAKA TEKNIK UTAMA",
          img: require("@/assets/bukaka.jpg"),
        },
        {
          title: "PT. WASKITA KARYA",
          img: require("@/assets/waskita.jpg"),
        },
        {
          title: "PT. CIPTA DIMENSI BAJA NUSATARA",
          img: require("@/assets/cipta-dimensi.jpg"),
        },
        {
          title: "PT. PRIMATAMA KONSTRUKSI",
          img: require("@/assets/primatama.jpg"),
        },
        {
          title: "PT. WAAGNER BIRO INDONESIA",
          img: require("@/assets/waagner.png"),
        },
        {
          title: "PT. KARUNIA BERCA INDONESIA",
          img: require("@/assets/karunia.jpg"),
        },
        {
          title: "PT. GALVINDO INTI SELARAS",
          img: require("@/assets/galvindo.png"),
        },
      ],
      itemServices: [
        { title: "Repair" },
        { title: "Painting" },
        { title: "Carpentry" },
        { title: "Plumbing" },
        { title: "Remodeling" },
        { title: "Electrical" },
      ],
      itemsSubject: ["Repair", "Painting", "Renovation", "Plumbing"],
      transparent: "rgba(255, 255, 255, 0)",
      itemsToolbar: [
        {
          icon: "mdi-account-multiple-check",
          text: "SDM Berpengalaman dan Tepercaya",
        },
        { icon: "mdi-check-decagram", text: "Pelayanan Istimewa" },
        { icon: "mdi-shield-check", text: "Kualitas Terjamin" },
        { icon: "mdi-tag-multiple", text: "Harga Terendah" },
      ],
      breadcumbs: [
        {
          text: "Homepage",
          disabled: false,
          href: "homepage",
        },
        {
          text: "About",
          disabled: true,
          href: "about",
        },
      ],
      categories: [
        {
          icon: "mdi-math-compass",
          title: "Konstruksi",
          subtitle:
            "Kami Menyediakan Jasa Konstruksi kerangka besi baja dan baja ringan.",
          to: "painting",
        },
        {
          icon: "mdi-shovel",
          title: "Pembangunan",
          to: "painting",
          subtitle:
            "Pembangunan untuk kantor, rumah tinggal, ruko, pabrik atau gudang.",
        },
        {
          icon: "mdi-format-paint",
          title: "Interior Design",
          to: "painting",
          subtitle:
            "Menyediakan Interior Ruang pertemuan, direksi, kerja, resepsionis, ruang keluarga, kamar,counter bar dll.",
        },
        {
          icon: "mdi-box-shadow",
          title: "Baja dan Besi",
          to: "painting",
          subtitle:
            "Kami menyediakan pengadaan untuk Baja ringan , Besi Kanal CNP UNP dan Reng.",
        },
        {
          icon: "mdi-shield-plus",
          title: "Peralatan Keamanan",
          to: "painting",
          subtitle: "Kami menyediakan pengadaan untuk peralatan keamanan.",
        },
        {
          icon: "mdi-monitor-multiple",
          to: "painting",
          title: "Komputer",
          subtitle:
            "Kami menyediakan pengadaan Komputer, laptop dan printer untuk kebutuhan anda.",
        },
      ],
      // logo: base
      item: {
        title: "Halo, Justiperz!",
        subtitle: "PROFESSIONAL TILING",
      },
      contactImage: require("@/assets/contact.jpg"),
    };
  },
  methods: {
    alert() {
      alert("haii");
    },
    services(cat) {
      this.$router.push(`/${cat.to}`);
    },
  },
};
</script>

<style scoped>
.v-card--offset {
  opacity: 0.9;
  top: -450px;
  z-index: 5;
  left: 205px;
  border-top: 5px solid #0081db;
  color: white;
  position: relative;
}
.tagline-margin {
  margin-top: 30px;
}
.chat {
  top: -230px;
  position: relative;
  z-index: 1;
}
.custom {
  margin-inline-start: 170px;
  margin-inline-end: 170px;
}
.custom-margin-footer {
  margin-inline-start: 120px;
  margin-inline-end: 120px;
}
.paralax {
  height: 230px;
  margin-inline-start: 170px;
  margin-inline-end: 190px;
}
.paralaxGrad {
  background: linear-gradient(
    to right,
    navy,
    rgb(109, 199, 215),
    rgb(247, 247, 247)
  );
}
.gradient {
  background-color: rgba(34, 34, 34, 0.55);
}
.customProject {
  margin-inline-start: 30%;
}
.categories.hover-image {
  background-color: blue;
}
.outline {
  border: 1.5px solid purple;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
.serviceText {
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
}
.v-img--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}
.margin-auto {
  margin: auto;
}
.hover-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.satisfation {
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#3762d9),
    color-stop(35%, #6f66be),
    to(#8c00ff)
  );
  /* background : -webkit-gradient(linear,left top,right top,from(#e100ff),color-stop(35%,#bc64d6),to(#9e37d9)); */
  border-radius: 10px;
  position: relative;
}
.active {
  border: 1px blue;
}
.v-card-custom {
  transition: opacity 0.4s ease-in-out;
}

.v-card-custom:not(.on-hover) {
  opacity: 0.6;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
.garis {
  border: 3px solid navy;
}
.footer-padding {
  padding-inline-start: 200px;
  padding-inline-end: 200px;
}
.test {
  border-top: blue;
}
</style>
